<template functional>
  <div class="footer">
	  
    <div class="footer-content-column">
      <logo :is-transparent="true"></logo>
      <p class="network">© 2020-2025 中科淞塔（苏州）科技有限公司</p>
      <p class="network">苏公网安备32059002002963号 I 苏ICP备2024116025号</p>
    </div>
	
    <div class="footer-content-column">
      <div class="title">关于淞塔</div>
      <p>公司介绍</p>
      <p>检测案例</p>
	  <p>荣获奖项</p>
    </div>
	
    <div class="footer-content-column">
      <div class="title">产品中心</div>
      <p>光纤缺陷检测设备</p>
	  <p>木板分选设备</p>
	  <p>高精度管壳测量设备</p>
	  <p>其它工业视觉设备</p>
    </div>
	
	<div class="footer-content-column">
	  <div class="title">工业平台</div>
	  <p>文景大模型</p>
	  <p>智能AI平台</p>
	  <p>其它智能平台</p>
	</div>
	
	<div class="footer-content-column">
	  <!-- <div class="title" style="margin-left: 30px;">联系我们</div> -->
	  <div class="title">联系我们</div>
	  <img src="../assets/images/qrcode.jpg"  style="width: 100px;height: 100px;"/>.
	  <!-- <img src="../assets/images/dycode.jpg"  style="width: 100px;height: 100px;margin-left: 30px;"/> -->
	</div>
	
    <!-- <div class="footer-content-column">
      <div class="title">实时动态与招聘信息，请关注我们</div>
      <ul class="footer-content-column__contact">
        <li class="contact-item wechat">
          <svg width="33" height="32">
            <defs>
              <path id="icon-wechat_svg__a" d="M0 0h1440v251H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path fill="#FFF" d="M-1120-7901H320V126h-1440z" />
              <use
                fill="#1F2329"
                fill-rule="nonzero"
                transform="translate(-1120 -125)"
                xlink:href="#icon-wechat_svg__a"
              />
              <g transform="translate(.5)">
                <rect width="32" height="32" fill="#2EA121" rx="16" />
                <path
                  fill="#FFF"
                  d="M21.714 17.68a.798.798 0 0 0 .786-.808.798.798 0 0 0-.786-.809.798.798 0 0 0-.787.809c0 .446.352.809.787.809zm-3.84 0a.798.798 0 0 0 .786-.808.798.798 0 0 0-.786-.809.798.798 0 0 0-.787.809c0 .446.352.809.787.809zm-2.198-4.685a.939.939 0 0 0 .925-.952.939.939 0 0 0-.925-.95.939.939 0 0 0-.925.95c0 .526.414.952.925.952zm-4.65 0a.939.939 0 0 0 .926-.952.939.939 0 0 0-.925-.95.939.939 0 0 0-.926.95c0 .526.414.952.926.952zm11.078 10.184a.4.4 0 0 0-.325-.038 6.65 6.65 0 0 1-1.974.296c-3.2 0-5.794-2.226-5.794-4.972 0-2.745 2.594-4.97 5.794-4.97 3.2 0 5.795 2.225 5.795 4.97 0 1.517-.792 2.875-2.04 3.787a.308.308 0 0 0-.114.324l.273 1.07c.082.32-.08.447-.358.28l-1.257-.747zm-11.088-3.61a8.012 8.012 0 0 0 2.721.339 4.676 4.676 0 0 1-.235-1.466c0-2.995 2.853-5.423 6.373-5.423.123 0 .245.003.366.008C19.72 10.18 16.838 8 13.363 8 9.517 8 6.4 10.668 6.4 13.958c0 1.81.942 3.43 2.43 4.522a.43.43 0 0 1 .159.455l-.327 1.256c-.1.379.09.527.42.329l1.49-.895a.549.549 0 0 1 .444-.056z"
                />
              </g>
            </g>
          </svg>
        </li>
        <li class="contact-item douyin">
          <svg width="33" height="34">
            <defs>
              <path id="icon-douyin_svg__a" d="M0 0h1440v251H0z" />
              <filter
                id="icon-douyin_svg__b"
                width="537.5%"
                height="520%"
                x="-218.8%"
                y="-210%"
                filterUnits="objectBoundingBox"
              >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                  stdDeviation="12.5"
                />
                <feColorMatrix
                  in="shadowBlurOuter1"
                  result="shadowMatrixOuter1"
                  values="0 0 0 0 0.121568627 0 0 0 0 0.137254902 0 0 0 0 0.160784314 0 0 0 0.1 0"
                />
                <feMerge>
                  <feMergeNode in="shadowMatrixOuter1" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path fill="#FFF" d="M-1175-7900H265V127h-1440z" />
              <use
                fill="#1F2329"
                fill-rule="nonzero"
                transform="translate(-1175 -124)"
                xlink:href="#icon-douyin_svg__a"
              />
              <g transform="translate(.5 1)">
                <circle cx="16" cy="16" r="16" fill="#000" stroke="#000" />
                <g filter="url(#icon-douyin_svg__b)" transform="translate(4 4)">
                  <path
                    fill="#00F7EF"
                    d="M10.385 10.126v-.773a6.04 6.04 0 0 0-.813-.059c-3.326 0-6.031 2.697-6.031 6.01a6 6 0 0 0 2.575 4.922 5.976 5.976 0 0 1-1.62-4.093c0-3.266 2.629-5.93 5.89-6.007"
                  />
                  <path
                    fill="#00F7EF"
                    d="M10.528 18.878a2.751 2.751 0 0 0 2.749-2.641l.005-13.087h2.4a4.532 4.532 0 0 1-.078-.83h-3.277l-.005 13.088a2.751 2.751 0 0 1-4.028 2.326 2.753 2.753 0 0 0 2.234 1.144m9.635-11.287v-.727a4.542 4.542 0 0 1-2.483-.736 4.565 4.565 0 0 0 2.483 1.463"
                  />
                  <path
                    fill="#FF004F"
                    d="M17.68 6.128a4.513 4.513 0 0 1-1.12-2.978h-.879a4.551 4.551 0 0 0 2 2.978M9.572 12.56a2.753 2.753 0 0 0-2.754 2.745c0 1.054.6 1.97 1.477 2.43a2.72 2.72 0 0 1-.522-1.602 2.753 2.753 0 0 1 2.755-2.745c.283 0 .555.047.812.127v-3.334a6.04 6.04 0 0 0-.812-.058c-.048 0-.095.002-.143.003v2.56a2.721 2.721 0 0 0-.813-.126"
                  />
                  <path
                    fill="#FF004F"
                    d="M20.163 7.591v2.538a7.813 7.813 0 0 1-4.559-1.46v6.636c0 3.314-2.706 6.01-6.032 6.01a6.01 6.01 0 0 1-3.456-1.089 6.025 6.025 0 0 0 4.411 1.918c3.326 0 6.032-2.696 6.032-6.01V9.496a7.812 7.812 0 0 0 4.56 1.461V7.693c-.328 0-.647-.036-.956-.102"
                  />
                  <path
                    fill="#FFF"
                    d="M15.604 15.305V8.669a7.813 7.813 0 0 0 4.56 1.46V7.591a4.565 4.565 0 0 1-2.484-1.463 4.552 4.552 0 0 1-1.999-2.978h-2.399l-.005 13.087a2.752 2.752 0 0 1-4.983 1.497 2.745 2.745 0 0 1-1.476-2.43 2.753 2.753 0 0 1 2.754-2.744c.284 0 .556.046.813.127v-2.56c-3.26.075-5.89 2.74-5.89 6.006 0 1.58.617 3.019 1.62 4.093a6.01 6.01 0 0 0 3.457 1.09c3.326 0 6.032-2.697 6.032-6.011"
                  />
                </g>
              </g>
            </g>
          </svg>
        </li>
        <li class="contact-item toutiao">
          <svg width="33" height="32">
            <defs>
              <path id="icon-toutiao_svg__a" d="M0 0h1440v251H0z" />
              <circle id="icon-toutiao_svg__b" cx="16" cy="16" r="16" />
              <filter
                id="icon-toutiao_svg__c"
                width="428.1%"
                height="428.1%"
                x="-164.1%"
                y="-164.1%"
                filterUnits="objectBoundingBox"
              >
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                  stdDeviation="12.5"
                />
                <feColorMatrix
                  in="shadowBlurOuter1"
                  result="shadowMatrixOuter1"
                  values="0 0 0 0 0.121568627 0 0 0 0 0.137254902 0 0 0 0 0.160784314 0 0 0 0.1 0"
                />
                <feMerge>
                  <feMergeNode in="shadowMatrixOuter1" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
              <path id="icon-toutiao_svg__e" d="M0 0h32v32H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path fill="#FFF" d="M-1229-7901H211V126h-1440z" />
              <use
                fill="#1F2329"
                fill-rule="nonzero"
                transform="translate(-1229 -125)"
                xlink:href="#icon-toutiao_svg__a"
              />
              <g transform="translate(.5)">
                <mask id="icon-toutiao_svg__d" fill="#fff">
                  <use xlink:href="#icon-toutiao_svg__b" />
                </mask>
                <use fill="#FFF" xlink:href="#icon-toutiao_svg__b" />
                <g filter="url(#icon-toutiao_svg__c)" mask="url(#icon-toutiao_svg__d)">
                  <mask id="icon-toutiao_svg__f" fill="#fff">
                    <use xlink:href="#icon-toutiao_svg__e" />
                  </mask>
                  <path
                    fill="#FFF"
                    d="M26.308 32H5.692A5.699 5.699 0 0 1 0 26.307V5.692A5.699 5.699 0 0 1 5.692 0h20.616A5.698 5.698 0 0 1 32 5.692v20.615A5.699 5.699 0 0 1 26.308 32"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#DDD"
                    d="M5.692.241A5.457 5.457 0 0 0 .24 5.691v20.616a5.457 5.457 0 0 0 5.452 5.451h20.616a5.457 5.457 0 0 0 5.452-5.45V5.691A5.457 5.457 0 0 0 26.308.24H5.692zM26.308 32H5.692A5.699 5.699 0 0 1 0 26.307V5.692A5.698 5.698 0 0 1 5.692 0h20.616A5.698 5.698 0 0 1 32 5.692v20.615A5.699 5.699 0 0 1 26.308 32z"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#FF373C"
                    d="M32 25.297L0 27V7.703L32 6z"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#FFF"
                    d="M9 13v-1.66L5 11v1.66zm-4 1v1.66L9 16v-1.66zm10 4.457L3 19v-1.457L15 17zm14-1L17 18v-1.457L29 16zm-1-6.883L19 11V9.426L28 9z"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#FFF"
                    d="M12 9l-1.861.105c-.05 3.999-.1 6.251-.768 7.863-.678 1.635-2.123 2.989-5.001 5.686L4 23l2.932-.165C11.71 18.28 11.896 17.29 12 9m1.218 11L11 20.121 12.782 23 15 22.879zm14-1L25 19.121 26.782 22 29 21.879zM21 19l-2.218.114L17 22l2.218-.114zm3 2.89L22 22v-6.89l2-.11zm2.138-12.798v1.18c-1.179.953-3.558 2.569-10.138 3.934V16c7.992-1.62 10.718-3.9 12-5.044V9l-1.862.092z"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#FFF"
                    d="M18.917 11.162a16.953 16.953 0 0 0-.245-.162L17 12.059s.746.524.827.578C19.194 13.55 21.69 15.214 29 16v-1.793c-6.64-.748-8.859-2.228-10.083-3.045"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                  <path
                    fill="#FFF"
                    d="M17 11.954L18.815 13 21 9.79 19.003 9z"
                    mask="url(#icon-toutiao_svg__f)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </li>
        <li class="contact-item lingying">
          <svg width="33" height="32">
            <defs>
              <path id="icon-linkedin_svg__a" d="M0 0h1440v251H0z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <path fill="#FFF" d="M-1284-7901H156V126h-1440z" />
              <use
                fill="#1F2329"
                fill-rule="nonzero"
                transform="translate(-1284 -125)"
                xlink:href="#icon-linkedin_svg__a"
              />
              <circle cx="16" cy="16" r="16" fill="#1D87BD" transform="translate(.5)" />
              <path
                fill="#FFF"
                fill-rule="nonzero"
                d="M8.58 24V12.827h3.413V24H8.58M12.1 9.733c.027.96-.693 1.734-1.84 1.734-1.067 0-1.76-.774-1.76-1.734C8.5 8.747 9.22 8 10.313 8c1.094 0 1.787.747 1.787 1.733M21.06 24v-6.187c0-1.44-.48-2.426-1.733-2.426-.934 0-1.494.666-1.76 1.306-.08.24-.107.56-.107.88V24h-3.413v-7.6c0-1.387-.054-2.56-.08-3.573h2.96l.16 1.573h.053c.453-.747 1.573-1.813 3.413-1.813 2.24 0 3.947 1.52 3.947 4.826V24h-3.44"
              />
            </g>
          </svg>
        </li>
      </ul>
    </div>
  </div> -->
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.footer {
  height: 220px;
  min-width: @main-width;
  background: rgba(0, 0, 0, 1);
  color: #fff;
  display: flex;
  font-size: @font-size-small;
  padding: 0 100px;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  &-content-column {
    padding: 0 40px;
    height: 100px;
    .title {
		margin-top: -20px;
		margin-bottom: 20px;
		font-size: 20px;
      color: @secondary-text-color;
    }
	.network{
		color: @secondary-text-color;
	}
    &:last-child {
      width: 340px;
      padding: 0 80px;
    }
    & + & {
      text-align: center;
      flex: 1;
      border-left: 1px solid @border-dark-color;
    }

    &__contact {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .contact-item {
        border-radius: 50%;
        width: 33px;
        height: 33px;
        overflow: hidden;
      }
    }
  }
}
</style>
